"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.promptItem = exports.modelOptions = exports.formRules = exports.defaultFormData = void 0;
var modelOptions = exports.modelOptions = [
// { label: 'GPT-3.5 Turbo', value: 'gpt-3.5-turbo' },
// { label: 'GPT-4', value: 'gpt-4' },
// { label: 'GPT-4 Turbo', value: 'gpt-4-turbo' },
{
  label: 'GPT-4o',
  value: 'gpt-4o'
}];
var defaultFormData = exports.defaultFormData = {
  // configId: '',
  application: '',
  remark: '',
  status: 1,
  details: []
};
var promptItem = exports.promptItem = {
  detailId: '',
  model: '',
  promptLabel: '',
  promptContent: '',
  temperature: 0.7,
  // 温度参数0.00-2.00
  maxTokens: 2000,
  // 最大令牌数 1
  // topP: 0.9, // Top P采样-发散性控制 0.00-1.00
  frequencyPenalty: 0,
  // 频率惩罚-减少重复内容 0.00-2.00
  presencePenalty: 0,
  // 存在惩罚-鼓励新话题 0.00-2.00
  stopWords: '' // 中止词-遇到这些词停止生成
};
var formRules = exports.formRules = {
  application: [{
    required: true,
    trigger: ['blur', 'change'],
    message: '请选择应用'
  }],
  status: [{
    required: true,
    trigger: ['blur', 'change'],
    message: '请选择状态'
  }]
};